export const getComponentName = (componentStack) => {
  return componentStack?.split(' ')
    ?.find((line) => line.includes(':'))
    ?.split(':')[0]
    ?.replace(/[()]/g, '') || '';
};
